// PRELUDD
import favicon16x16Preludd from 'url:../../../resource/favicon/favicon-16x16.png';
import favicon32x32Preludd from 'url:../../../resource/favicon/favicon-32x32.png';
import faviconApple144x144Preludd from 'url:../../../resource/favicon/apple-touch-icon-144x144.png';
import faviconApple152x152Preludd from 'url:../../../resource/favicon/apple-touch-icon-152x152.png';
import faviconAndroid192x192Preludd from 'url:../../../resource/favicon/android-chrome-192x192.png';
import faviconAndroid384x384Preludd from 'url:../../../resource/favicon/android-chrome-384x384.png';
import faviconMs144x144Preludd from 'url:../../../resource/favicon/mstile-144x144.png';
// PAYVIEW pathFavicon
import favicon16x16Payview from 'url:../../../resource/favicon/payview/favicon-16x16.png';
import favicon32x32Payview from 'url:../../../resource/favicon/payview/favicon-32x32.png';
import faviconApple144x144Payview from 'url:../../../resource/favicon/payview/apple-touch-icon-144x144.png';
import faviconApple152x152Payview from 'url:../../../resource/favicon/payview/apple-touch-icon-152x152.png';
import faviconAndroid192x192Payview from 'url:../../../resource/favicon/payview/android-chrome-192x192.png';
import faviconAndroid384x384Payview from 'url:../../../resource/favicon/payview/android-chrome-384x384.png';
import faviconMs144x144Payview from 'url:../../../resource/favicon/payview/mstile-144x144.png';

/* -------------------------------------------------------------------------- */
/*                               DEFAULT SETS                                 */
/* -------------------------------------------------------------------------- */

const defaultFavicons = {
    base16x16: favicon16x16Preludd,
    base32x32: favicon32x32Preludd,
    apple144x144: faviconApple144x144Preludd,
    apple152x152: faviconApple152x152Preludd,
    ms144x144: faviconMs144x144Preludd,
    android192x192: faviconAndroid192x192Preludd,
    android384x384: faviconAndroid384x384Preludd
};

const defaultPayviewFavicons = {
    base16x16: favicon16x16Payview,
    base32x32: favicon32x32Payview,
    apple144x144: faviconApple144x144Payview,
    apple152x152: faviconApple152x152Payview,
    ms144x144: faviconMs144x144Payview,
    android192x192: faviconAndroid192x192Payview,
    android384x384: faviconAndroid384x384Payview
};

/* -------------------------------------------------------------------------- */
/*                          NORMALIZATION LAYER                               */
/* -------------------------------------------------------------------------- */

const normalizeValue = (value) => {
    if (!value) { return undefined; }

    // If backend sends object like { url: '...' }
    if (typeof value === 'object' && value.url) {
        return typeof value.url === 'string' ? value.url : undefined;
    }

    return typeof value === 'string' ? value : undefined;
};

const normalizeFavicons = (favicons = {}) => ({
    base16x16: normalizeValue(favicons.base16x16),
    base32x32: normalizeValue(favicons.base32x32),
    apple144x144: normalizeValue(favicons.apple144x144),
    apple152x152: normalizeValue(favicons.apple152x152),
    ms144x144: normalizeValue(favicons.ms144x144),
    android192x192: normalizeValue(favicons.android192x192),
    android384x384: normalizeValue(favicons.android384x384)
});

/* -------------------------------------------------------------------------- */
/*                               ALL FAVICONS                                 */
/* -------------------------------------------------------------------------- */

const getFavicons = (domain, isCustomPay) => {
    if (domain?.pathFavicon && typeof domain.pathFavicon === 'object') {
        return normalizeFavicons(domain.pathFavicon);
    }

    if (isCustomPay) {
        return defaultPayviewFavicons;
    }

    return defaultFavicons;
};

/* -------------------------------------------------------------------------- */
/*                               MAIN FAVICON                                 */
/* -------------------------------------------------------------------------- */

const getMainFavicon = (domain, isCustomPay) => {
    const favicons = getFavicons(domain, isCustomPay);

    return (
        favicons.android384x384 ||
        favicons.android192x192 ||
        favicons.apple152x152 ||
        favicons.apple144x144 ||
        favicons.ms144x144 ||
        favicons.base32x32 ||
        favicons.base16x16
    );
};

/* -------------------------------------------------------------------------- */
/*                             DEVICE DETECTION                               */
/* -------------------------------------------------------------------------- */

const iphoneDeviceClassname = () => {
    if (typeof navigator !== 'undefined' &&
        /\biphone\b/.test(navigator.userAgent.toLowerCase())) {
        return 'mobile-ios ';
    }
    return '';
};

export {
    getMainFavicon,
    getFavicons,
    iphoneDeviceClassname
};